import React from 'react'

const CloseIcon = () => {
    return (
        <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="close-icon"
        >
            <g id="icon - nav - exit">
                <path
                    id="cross_icon_24"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.00183 7.5L14.6729 1.83887C14.7752 1.7402 14.8569 1.62218 14.913 1.49169C14.9692 1.36121 14.9987 1.22086 15 1.07884C15.0012 0.936831 14.9741 0.795992 14.9202 0.664549C14.8663 0.533105 14.7868 0.413687 14.6862 0.313264C14.5856 0.212841 14.466 0.133423 14.3343 0.0796455C14.2026 0.0258676 14.0615 -0.00119368 13.9193 4.03831e-05C13.777 0.00127445 13.6364 0.0307794 13.5057 0.0868335C13.375 0.142888 13.2567 0.224368 13.1579 0.326522L7.48683 5.98766L1.81576 0.326522C1.61369 0.131694 1.34304 0.023889 1.06212 0.0263259C0.781193 0.0287628 0.512466 0.141247 0.313814 0.33955C0.115163 0.537853 0.00248167 0.80611 4.05026e-05 1.08654C-0.00240066 1.36698 0.105594 1.63715 0.300763 1.83887L5.97183 7.5L0.300763 13.1611C0.105594 13.3629 -0.00240066 13.633 4.05026e-05 13.9135C0.00248167 14.1939 0.115163 14.4621 0.313814 14.6604C0.512466 14.8588 0.781193 14.9712 1.06212 14.9737C1.34304 14.9761 1.61369 14.8683 1.81576 14.6735L7.48683 9.01234L13.1579 14.6735C13.2567 14.7756 13.375 14.8571 13.5057 14.9132C13.6364 14.9692 13.777 14.9987 13.9193 15C14.0615 15.0012 14.2026 14.9741 14.3343 14.9204C14.466 14.8666 14.5856 14.7872 14.6862 14.6867C14.7868 14.5863 14.8663 14.4669 14.9202 14.3355C14.9741 14.204 15.0012 14.0632 15 13.9212C14.9987 13.7791 14.9692 13.6388 14.913 13.5083C14.8569 13.3778 14.7752 13.2598 14.6729 13.1611L9.00183 7.5Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export default CloseIcon
